import { getJDISiteKeys } from '.';
import VisaPaySVG from '@/assets/icons/visaPay.svg';
import OrangePaySVG from '@/assets/icons/orangePay.svg';
import UnionPaySVG from '@/assets/icons/unionPay.svg';
import PayPalSVG from '@/assets/icons/payPal.svg';
import WeChatPaySVG from '@/assets/icons/weChatPay.svg';
import GooglePaySVG from '@/assets/icons/googlePay.svg';
import ApplePaySVG from '@/assets/icons/applePay.svg';
import KlarnaPaySVG from '@/assets/icons/klarnaPay.svg';
import IdealPaySVG from '@/assets/icons/idealPay.svg';
import BrightBankPaySVG from '@/assets/icons/brightBankPay.svg';
import MasterCardPaySVG from '@/assets/icons/masterCardPay.svg';

interface SiteConfig {
  [countryCode: string]: {
    footerPayList?: React.FC<React.SVGProps<SVGSVGElement>>[];
  };
}

interface MultiSiteConfigType {
  [siteCode: string]: SiteConfig;
}

const MultiSiteConfig: MultiSiteConfigType = {
  // 英国站
  ['UK-Site']: {
    // 该站点下的通用配置
    ['COMMON']: {
      footerPayList: [
        VisaPaySVG,
        OrangePaySVG,
        UnionPaySVG,
        PayPalSVG,
        WeChatPaySVG,
        GooglePaySVG,
        ApplePaySVG,
        KlarnaPaySVG,
      ],
    },
  },
  // 荷兰站
  ['NL-Site']: {
    // 该站点下的通用配置
    ['COMMON']: {
      footerPayList: [
        IdealPaySVG,
        BrightBankPaySVG,
        VisaPaySVG,
        OrangePaySVG,
        UnionPaySVG,
        PayPalSVG,
        WeChatPaySVG,
        GooglePaySVG,
        ApplePaySVG,
        KlarnaPaySVG,
        MasterCardPaySVG,
      ],
    },
    // 区分国家的配置 比利时
    ['BE']: {
      footerPayList: [
        BrightBankPaySVG,
        VisaPaySVG,
        OrangePaySVG,
        UnionPaySVG,
        PayPalSVG,
        WeChatPaySVG,
        GooglePaySVG,
        ApplePaySVG,
        KlarnaPaySVG,
        MasterCardPaySVG,
      ],
    },
    // 区分国家的配置 卢森堡
    ['LU']: {
      footerPayList: [
        BrightBankPaySVG,
        VisaPaySVG,
        OrangePaySVG,
        UnionPaySVG,
        PayPalSVG,
        WeChatPaySVG,
        GooglePaySVG,
        ApplePaySVG,
        KlarnaPaySVG,
        MasterCardPaySVG,
      ],
    },
  },
  // 德国站
  ['DE-Site']: {
    // 该站点下的通用配置
    ['COMMON']: {
      footerPayList: [
        IdealPaySVG,
        BrightBankPaySVG,
        VisaPaySVG,
        OrangePaySVG,
        UnionPaySVG,
        PayPalSVG,
        WeChatPaySVG,
        GooglePaySVG,
        ApplePaySVG,
        KlarnaPaySVG,
      ],
    },
  },
  // 法国站
  ['FR-Site']: {
    // 该站点下的通用配置
    ['COMMON']: {
      footerPayList: [
        BrightBankPaySVG,
        VisaPaySVG,
        OrangePaySVG,
        UnionPaySVG,
        PayPalSVG,
        WeChatPaySVG,
        GooglePaySVG,
        ApplePaySVG,
        KlarnaPaySVG,
      ],
    },
  },
};

interface MultiSiteConfigReturn {
  footerPayList?: React.FC<React.SVGProps<SVGSVGElement>>[];
}

export const getMultiSiteConfig = (): MultiSiteConfigReturn => {
  const siteKeys = getJDISiteKeys();
  const siteCode = siteKeys?.['JDI-Site'];
  const countryCode = siteKeys?.['JDI-Country'];
  if (siteCode && MultiSiteConfig[siteCode]) {
    return {
      ...MultiSiteConfig?.[siteCode]?.['COMMON'],
      ...MultiSiteConfig?.[siteCode]?.[countryCode],
    };
  }
  return {
    ...MultiSiteConfig?.['UK-Site']?.['COMMON'],
    ...MultiSiteConfig?.['UK-Site']?.[countryCode],
  };
};
